import type { CampaignReportPlatform } from '../types/global/campaignReport.types';

export function formatReportCompactNumber(value: number | null | undefined): string {
    const n = Number(value);
    if (!Number.isFinite(n)) return '0';
    if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
    if (n >= 1_000) return `${(n / 1_000).toFixed(1).replace(/\.0$/, '')}K`;
    return String(Math.round(n));
}

export function formatReportPercent(value: number | null | undefined, digits = 1): string {
    const n = Number(value);
    if (!Number.isFinite(n)) return '0%';
    return `${n.toFixed(digits)}%`;
}

export function formatReportUsd(value: number | null | undefined, fromCents = false): string {
    const n = Number(value);
    if (!Number.isFinite(n)) return '$0';
    const dollars = fromCents ? n / 100 : n;
    if (dollars >= 1_000) return `$${formatReportCompactNumber(dollars)}`;
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: dollars >= 100 ? 0 : 2,
    }).format(dollars);
}

export function formatWatchHours(seconds: number | null | undefined): string {
    const n = Number(seconds);
    if (!Number.isFinite(n) || n <= 0) return '0';
    const hours = n / 3600;
    if (hours >= 1000) return formatReportCompactNumber(hours);
    if (hours >= 10) return `${Math.round(hours)}`;
    return hours.toFixed(1);
}

export function platformLabel(platform: string): string {
    switch (platform.toLowerCase()) {
        case 'instagram':
            return 'Instagram';
        case 'tiktok':
            return 'TikTok';
        case 'youtube':
            return 'YouTube';
        default:
            return platform;
    }
}

export function platformShortLabel(platform: CampaignReportPlatform | string): string {
    switch (platform.toLowerCase()) {
        case 'instagram':
            return 'IG';
        case 'tiktok':
            return 'TK';
        case 'youtube':
            return 'YT';
        default:
            return platform.slice(0, 2).toUpperCase();
    }
}

export function syncStatusLabel(status: string): string {
    switch (status) {
        case 'pending':
            return 'Syncing';
        case 'synced':
            return 'Synced';
        case 'failed':
            return 'Failed';
        case 'unsupported':
            return 'Unsupported';
        case 'stale':
            return 'Stale';
        default:
            return status;
    }
}
